export class TrainingScheduleVersion {
	public id;
	public name;

	constructor() {
	}
} 
